import React, { useCallback, useMemo, useRef, useState } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { datetimeShortFromUTC } from 'utils/dayjs';
import Icon from 'components/Icon';
import ContextMenu from './ContextMenu';
import './index.sass';

const { block, el } = bem('context-chip', 'event-chip');
const ContextEventChip = ({event, number, openTransferForm}) => {
    const [ isOpen, setIsOpen ] = useState(false);

    const open = useCallback(() => {
        setIsOpen(old => !old);
    }, [])

    const close = useCallback(() => {
        setIsOpen(false);
    }, [])

    const buttonRef = useRef(null);

    const showMenu = useMemo(() => {
        return event.isTransferEnabled || event.canStartMeeting;
    }, [event.isTransferEnabled, event.canStartMeeting])

    const eventFormat = (utcDate) => {
        const { date, time } = datetimeShortFromUTC(utcDate);
        return `${ date } ${ time }`;
    };

    return (
        <div className={ block() }>
            <div className={ el('content')}>
                <Text className={ el('number') }>#{ number + 1 }</Text>
                <Text className={ el('date') }>{ eventFormat(event.startDate) }</Text>
            </div>
            { showMenu && <div className={el('context')} ref={buttonRef} >
                <div className={el('button')} onClick={open}>
                    <Icon name={'dots-three-outline-vertical'} />
                </div>
                 <ContextMenu
                    anchorEl={buttonRef?.current}
                    open={isOpen}
                    onClose={close}
                    openTransferForm={openTransferForm}
                    transferEnabled={event.isTransferEnabled}
                    orderId={event.orderId}
                    canStartMeeting={event.canStartMeeting}
                />
            </div> }
        </div>
    )
}

export default ContextEventChip;
